import React, { useRef } from "react";
import { Link } from "react-router-dom";
import SiteFooter from "../components/layout/SiteFooter";
import SiteNavbar from "../components/layout/SiteNavbar";
import GeneralLineIcon from "../components/common/GeneralLineIcon";
import useRevealOnScroll from "../components/common/useRevealOnScroll";

import edificioUba from "../assets/media/img/edificio-uba.jpg";

export default function Fundacion() {
    const pageRef = useRef(null);
    useRevealOnScroll(pageRef);
    return (
        <div className="fundacion" ref={pageRef}>
            <SiteNavbar activeSection="fundacion" />
            <section className="hero">
                <div className="hero-mesh"></div>
                <div className="hero-inner">
                    <div className="hero-bread">
                        <Link to="/">Inicio </Link>→ La Fundación
                    </div>
                    <div className="hero-content">
                        <h1> Formamos profesionales para transformar la <span> salud pública</span> </h1>
                        <p className="hero-desc">
                            La Fundación Iberoamericana de Salud Pública es una organización de la sociedad civil sin fines de lucro cuyo objetivo principal es formar profesionales
                            con los altos estándares académicos y tecnológicos que se requieren hoy en día.
                        </p>
                    </div>
                </div>
            </section>
            <section className="about reveal">
                <div className="about-inner">
                    <div>
                        <div className="about-tag">Quiénes somos</div>
                        <h2>Una ONG creada por profesionales multidisciplinarios del sector salud</h2>
                        <p>
                            La Fundación Iberoamericana de Salud Pública (FISP) es una organización sin fines de lucro dedicada a la formación académica de posgrado y la divulgación en salud pública. Desde sus orígenes, FISP se consolidó como un espacio de referencia para profesionales de la salud que buscan especializarse con rigor académico y perspectiva iberoamericana.
                        </p>
                        <p>
                            En alianza con la Facultad de Medicina de la Universidad de Buenos Aires (UBA), FISP ofrece diplomaturas y posgrados en áreas como Nutrición Clínica, Enfermería Oncológica, Cuidados Paliativos, Toxicología, Criminalística, Big Data e Inteligencia Artificial en Salud, entre otras. Su propuesta combina contenido actualizado, cuerpo docente especializado y modalidades flexibles pensadas para profesionales en actividad.
                        </p>
                        <p>
                            Más allá de la formación, FISP produce contenido audiovisual y periodístico de salud a través de FISP TV y sus plataformas digitales, posicionándose también como un medio de comunicación en salud con llegada masiva.
                        </p>
                    </div>
                    <div className="about-img">
                        <img src="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=600&q=80" alt="Institución de salud pública" />
                    </div>
                </div>
            </section>
            <section className="mv reveal">
                <div className="mv-inner">
                    <div className="mv-grid">
                        <div className="mv-card">
                            <h3>Misión</h3>
                            <p>
                                Democratizar el acceso al conocimiento en salud pública a través de una oferta académica de excelencia, flexible e innovadora, que forme profesionales capaces de transformar los sistemas de salud en Iberoamérica. FISP articula educación, investigación y divulgación para construir una comunidad comprometida con la salud como derecho.
                            </p>
                        </div>
                        <div className="mv-card">
                            <h3>Visión</h3>
                            <p>
                                Ser la institución de referencia en formación y comunicación en salud pública de habla hispana, reconocida por la calidad de sus programas, la solidez de sus alianzas académicas y su capacidad de anticiparse a los desafíos sanitarios del siglo XXI.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="pillars">
                <div className="pillars-mesh"></div>
                <div className="pil-inner">
                    <div className="pil-head">
                        <h2>Tres pilares, una fundación</h2>
                        <p>Educación, multimedio y tecnología al servicio de la salud pública.</p>
                    </div>
                    <div className="pil-grid reveal">
                        <div className="p-card">
                            <span className="ico">
                                <GeneralLineIcon name="education" />
                            </span>
                            <h3>Educación</h3>
                            <p>
                                Más de 30 propuestas académicas con doble titulacion FISP y Facultad de Medicina de la Universidad de Buenos Aires. Formación 100% online
                                con prácticas presenciales.
                            </p>
                        </div>
                        <div className="p-card">
                            <span className="ico">
                                <GeneralLineIcon name="media" />
                            </span>
                            <h3>Multimedio</h3>
                            <p>
                                FISP TV: informes, entrevistas, podcasts y vlogs dedicados a la salud y el bienestar. Segmentos de contenido audiovisual en YouTube,
                                Spotify e Instagram.
                            </p>
                        </div>
                        <div className="p-card">
                            <span className="ico">
                                <GeneralLineIcon name="technology" />
                            </span>
                            <h3>Tecnología</h3>
                            <p>
                                Proyectos tecnológicos en salud: telemedicina, historia clínica única, sistemas de IA médicos, desarrollo de plataformas digitales para
                                instituciones médicas y gubernamentales.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="metrics reveal">
                <div className="met-inner">
                    <div className="met-grid">
                        <div className="m-card">
                            <div className="num">
                                12
                                <span>+</span>
                            </div>
                            <div className="lab">Países con presencia</div>
                        </div>
                        <div className="m-card">
                            <div className="num">
                                1.500
                                <span>+</span>
                            </div>
                            <div className="lab">Alumnos por año</div>
                        </div>
                        <div className="m-card">
                            <div className="num">32</div>
                            <div className="lab">Programas académicos</div>
                        </div>
                        <div className="m-card">
                            <div className="num">
                                FISP
                                <span>+</span>
                                UBA
                            </div>
                            <div className="lab">Doble titulación</div>
                        </div>
                        <div className="m-card">
                            <div className="num">
                                350K
                                <span>+</span>
                            </div>
                            <div className="lab">Seguidores en redes</div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="alliance reveal">
                <div className="all-inner">
                    <div className="all-text">
                        <span className="tag">Alianza académica</span>
                        <h2>Doble titulación con la Facultad de Medicina de la Universidad de Buenos Aires</h2>
                        <p>
                            Todos los programas de FISP otorgan una doble titulación: el certificado de la Fundación Iberoamericana de Salud Pública y el de la Facultad de Medicina
                            de la Universidad de Buenos Aires, una de las instituciones académicas más prestigiosas de Latinoamérica.
                        </p>
                        <p>Esta alianza garantiza el más alto estándar de calidad académica y reconocimiento profesional a nivel nacional e internacional.</p>
                    </div>
                    <div className="all-visual">
                        <img src={edificioUba} alt="Universidad de Buenos Aires - Facultad de Medicina" />
                    </div>
                </div>
            </section>
            {/* <section className="obj reveal">
                <div className="obj-inner">
                    <div className="obj-head">
                        <span className="tag">Nuestros objetivos</span>
                        <h2>Lo que nos impulsa cada día</h2>
                    </div>
                    <div className="obj-grid">
                        <div className="o-card">
                            <span className="ico">🎓</span>
                            <h4>Integrar docencia, asistencia e investigación</h4>
                            <p>Con el criterio de creatividad, innovación y conocimiento en cada proyecto que desarrollamos.</p>
                        </div>
                        <div className="o-card">
                            <span className="ico">??</span>
                            <h4>Promover la equidad en salud</h4>
                            <p>Garantizar el acceso a formación de calidad sin importar la ubicación geográfica del profesional.</p>
                        </div>
                        <div className="o-card">
                            <span className="ico">🩺</span>
                            <h4>Intervenir en el mejoramiento de la salud</h4>
                            <p>Participando en programas de prevención primaria, secundaria y terciaria, y prestaciones de salud.</p>
                        </div>
                        <div className="o-card">
                            <span className="ico">💻</span>
                            <h4>Implementar nuevas tecnologías</h4>
                            <p>Para el desarrollo de la salud pública con el propósito de brindar bienestar a la población.</p>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className="cta">
                <h2>Sumate a la comunidad FISP</h2>
                <p>Formación de excelencia, contenido de salud y tecnología al servicio de la sociedad.</p>
                <div className="cta-btns">
                    <Link to="/educativo" className="btn-w">
                        Explorar programas académicos
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <path d="M5 12h14M12 5l7 7-7 7"></path>
                        </svg>
                    </Link>
                </div>
            </section>
            <SiteFooter />
        </div>
    );
}
